import { observer } from "mobx-react-lite";
import DetailBar, { DetailBarStripe } from "../../components/DetailBar";
import { Modal } from "../../components/Modal";
import SimpleSwitch from "../../components/SimpleSwitch";
import DepthIcon from "../../icons/DepthIcon";
import FrameStripsIcon from "../../icons/FrameStripsIcon";
import Height2Icon from "../../icons/Height2Icon";
import LengthIcon from "../../icons/LengthIcon";
import WidthIcon from "../../icons/WidthIcon";
import { store } from "../../stores/Store";
import { publicUrl } from "../../utils/url";
import Img from "../../components/Img";
import { _t } from '../../utils/Lang';



const BackDimensionsModal = observer(props => {
    return <Modal
        onClose={e => {
            store.closeBedheadDimensions();
        }}
        isOpen={store.isOpenBedheadDimensions}

    >
        <div className="ModalSizes">
            <div className='c-h1'>{_t('headboard_height_title')}</div>
            <div className="c-p fw-bold mt-4">{_t('headboard_height_desc')}</div>

            <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-4">
                {
                    store.bedheadOptions.map((item, index) => {
                        return <SimpleSwitch
                            className="SimpleSwitch--fullbg"
                            key={index}
                            name={item.name}
                            checked={item.valueId === store.getStepByOptionId(item.optionId)?.previewValue}
                            price={null}
                            showChecked={false}
                            onClick={() => {
                                store.updateSelectedHeight(item.id);
                                // store.updateSelectedPreviewHeight(item.id);
                                // store.updateOption(item.optionId, item.valueId);
                                store.updateOptionPreview(item.optionId, item.valueId);
                            }}
                        />
                    })
                }

            </div>
            <div className='text-center'>
                <div className="relative" style={{ aspectRatio: '16/9' }}>
                    <Img className='d-block m-auto' src={store.renderPersonPreviewImageUrl} alt="" />
                </div>
            </div>
        </div>


    </Modal>

});
BackDimensionsModal.displayName = 'BackDimensionsModal';

export default BackDimensionsModal